<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Profilo"></app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <ul class="list-unstyled">
                        <li><span class="font-weight-semibold">Cognome:</span> {{ utenteService.utente.cognome }}</li>
                        <li><span class="font-weight-semibold">Nome:</span> {{ utenteService.utente.nome }}</li>
                        <li><span class="font-weight-semibold">Codice fiscale:</span> {{ utenteService.utente.codiceFiscale }}</li>
                        <li><span class="font-weight-semibold">Email:</span> {{ utenteService.utente.email }}</li>
                        <li><span class="font-weight-semibold">ENTE:</span> {{ utenteService.utente.ente | anagraficaEnte: (datalist.ente || []) }}</li>
                        <li><span class="font-weight-semibold">Ruolo:</span> {{ utenteService.utente.ruolo | anagraficaRuolo: (datalist.ruolo || []) }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>